import styled from 'styled-components';

const Container = styled.section`
    display: flex;
    flex-direction: column;
  
`;

export default Container;
